import defaultActions from './default';
import { fetchCollection } from '../api';

const ENTITIES = 'SATELLITES';
const ENTITY = 'SATELLITE';
const Entity = 'Satellite';
const entityName = 'satellite';
const ENTITIES_COLLECTION = 'satellites';

const entityActions = defaultActions({
  ENTITIES,
  ENTITY,
  Entity,
  entityName,
  ENTITIES_COLLECTION,
  fetchCollectionByStandardUser: fetchCollection,
});
export const { ACTIONS_NAMES_DICT } = entityActions;

export const { ENTITY_ACTIONS } = entityActions;
export const { fetchEntities } = entityActions;

export const { createEntity } = entityActions;

export const { updateEntity } = entityActions;
export const { archiveEntity } = entityActions;
export const { entitiesCleanUp } = entityActions;
export const { clearEntitiesDataLogout } = entityActions;
